// modules
import { createAction } from 'redux-actions'

// actions
export const setMeasurementList = createAction('SET_MEASUREMENT_LIST')
export const setMeasurementValue = createAction('SET_MEASUREMENT_VALUE')

export const setMeasurementPatientList = createAction(
  'SET_MEASUREMENT_PATIENT_LIST'
)
export const setMeasurementPatientListAssigned = createAction(
  'SET_MEASUREMENT_PATIENT_LIST_ASSIGNED'
)
export const setMeasurementPatientValue = createAction(
  'SET_MEASUREMENT_PATIENT_VALUE'
)
export const setMeasurementDashboardList = createAction(
  'SET_MEASUREMENT_DASHBOARD_LIST'
)

export const setMeasurementPatientReadingList = createAction(
  'SET_MEASUREMENT_PATIENT_READING_LIST'
)
export const setMeasurementPatientReadingValue = createAction(
  'SET_MEASUREMENT_PATIENT_READING_VALUE'
)

export const setMeasurementPatientReadingAnswer = createAction(
  'SET_MEASUREMENT_PATIENT_READING_ANSWER'
)

export const setMeasurementPredefinedFilter = createAction(
  'SET_MEASUREMENT_PREDEFINED_FILTER'
)

export const setMeasurementActiveTab = createAction(
  'SET_MEASUREMENT_ACTIVE_TAB'
)

export const setMeasurementChartInfo = createAction(
  'SET_MEASUREMENT_CHART_INFO'
)

export const setIsLoadingSync = createAction('SET_IS_LOADING_SYNC')

export const resetMeasurement = createAction('RESET_MEASUREMENT')
